import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(err) {
    return { error: err };
  }

  componentDidCatch(err, info) {
    console.error('[ErrorBoundary] Crash:', err?.message, err?.stack, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div style={{
        position: 'fixed', inset: 0, background: '#0C0C0F', color: '#ECEDF0',
        fontFamily: 'monospace', padding: 24, overflowY: 'auto', zIndex: 99999,
      }}>
        <div style={{ color: '#E4544A', fontWeight: 'bold', fontSize: 16, marginBottom: 12 }}>
          App Crash — bitte Screenshot schicken
        </div>
        <div style={{ fontSize: 13, marginBottom: 8, wordBreak: 'break-all' }}>
          {error.message}
        </div>
        <div style={{ fontSize: 11, color: '#888', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          {error.stack}
        </div>
      </div>
    );
  }
}
